import { Sliders, X } from 'lucide-react';
import { useMemo, useState } from 'react';
import i18n from '@/settings/i18n';
import Modal from '@/components/v2/common/Modal';
import Filters from '.';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';

const t = i18n.init('collections');

const MobileFilters = () => {
  const { selectedFilters } = useCollectionPageContext();
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const totalSelectedFilters = useMemo(
    () =>
      (selectedFilters?.categories.length ?? 0) +
      (selectedFilters?.brands.length ?? 0) +
      Object.keys(selectedFilters?.variants ?? {}).reduce(
        (acc, key) => acc + (selectedFilters?.variants[key]?.length ?? 0),
        0,
      ),
    [selectedFilters],
  );

  return (
    <>
      <button
        className="flex h-10 w-1/2 items-center justify-center gap-x-2 rounded rounded-r-none border border-r-0 border-gray-500 px-2 focus:outline-none lg:hidden"
        onClick={() => setShowMobileFilters(true)}
      >
        {t`Filters`}{' '}
        {totalSelectedFilters > 0 ? `(${totalSelectedFilters})` : ''}{' '}
        <Sliders className="h-4 w-4 shrink-0" />
      </button>
      {showMobileFilters && (
        <Modal
          onClose={() => setShowMobileFilters(false)}
          isOpen={showMobileFilters}
        >
          <div className="sticky top-0 z-[70] flex items-center justify-between bg-[#f4f4f4] p-4 text-sm">
            <div>
              <h1 className="w-full text-base font-extrabold leading-5">
                {t`Filters`}
              </h1>
            </div>
            <button
              className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-700 text-white  transition duration-150 ease-in-out hover:scale-110 focus:outline-none"
              onClick={() => setShowMobileFilters(false)}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div>
            <Filters />
          </div>
          <div className="sticky bottom-0 px-4 pb-4">
            <button
              onClick={() => setShowMobileFilters(false)}
              className="flex h-12 w-full items-center justify-center rounded bg-gray-700 p-2 text-sm font-bold text-white underline-offset-2 transition duration-150 ease-in-out hover:bg-gray-700/95 hover:underline hover:shadow-lg"
            >
              {t`Apply Filters`}
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default MobileFilters;
